export default __webpack_public_path__ + "static/media/BeenaDattani.08426eb2.jpg";